import * as React from 'react'
import {observer} from 'mobx-react'
import {filter} from 'lodash'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const PaymentProfileShort = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const formData = api.paymentForm.data

  const salutation = formData.stored_customer_salutation || ''
  const firstName = formData.stored_customer_firstname || ''
  const lastName = formData.stored_customer_lastname || ''
  const zipCode = formData.stored_customer_zip_code || ''
  const city = formData.stored_customer_city || ''

  let salutationLabel = api.trans(`payment_form.salutations.${salutation}`, {
    defaultValue: salutation,
  })

  if (salutation === 'none') {
    salutationLabel = null
  }

  const name = filter([salutationLabel, firstName, lastName], (v) => !!v).join(
    ' ',
  )
  const address = filter([zipCode, city], (v) => !!v).join(' ')

  return (
    <div className="payment-profile-short">
      <p className="main">
        <span className="name">{name}</span>
        <span className="address">{address}</span>
      </p>
    </div>
  )
})
